import { type GenericMap } from "@common/declarations";
import { createContext } from "react";

export type TourAdvanceOn = {
  event: "click";
};
export type TourStepName = string | GenericMap<string>;

export type TourContextStep = {
  advancedOn?: TourAdvanceOn;
  cancelIcon?: boolean;
  classNames?: string;
  context: "admin" | "next";
  hasFallbackStep?: boolean;
  isOverlayHidden?: boolean;
  name: string;
  noTarget?: boolean;
  overlayClipClass?: string;
  shouldTrackInput?: boolean;
  showLastStep?: boolean;
  text: string;
};
export type Tour = {
  activeStep: TourContextStep;
  name: string;
  steps: TourContextStep[];
};

export type TourContextProps = {
  dismiss: (isCancel: boolean) => void;
  getIsActiveStep: (...steps: Array<TourStepName | undefined>) => boolean;
  goTo: (name: string) => void;
  next: (path?: number) => void;
  restore: (tour?: Tour) => void;
  start: (name: string) => void;
  tour: Tour | null;
};

export const TourContext = createContext<TourContextProps | null>(null);

type TourAttributeData = {
  step?: string | null;
  goToStep?: string | null;
};
export const getTourAttributes = (data: TourAttributeData) => {
  const res: GenericMap<any> = {};

  if (data.step) {
    res["tour-step"] = data.step;
  }

  if (data.goToStep) {
    res["tour-go-to-step"] = data.goToStep;
  }

  return res;
};
